import { render, staticRenderFns } from "./review-component.vue?vue&type=template&id=2089488e&scoped=true&"
import script from "./review-component.vue?vue&type=script&lang=js&"
export * from "./review-component.vue?vue&type=script&lang=js&"
import style0 from "./review-component.vue?vue&type=style&index=0&id=2089488e&scoped=true&lang=css&"
import style1 from "./review-component.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089488e",
  null
  
)

export default component.exports